import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		button: {
			paddingLeft: 15,
			paddingRight: 15,
			// Match heights across the outlined Cancel and contained Add Office buttons at the
			// medium (36px) size — the outlined variant's 1px border otherwise renders it shorter.
			minHeight: 36,
		},
		closeButton: {
			position: "absolute",
			right: 8,
			top: 8,
			// The dialog header is white (theme MuiDialogTitle override), so the legacy white
			// icon was invisible. Matches the refreshed Add Member dialog.
			color: theme.palette.custom.textSecondary,
		},
		titleDivider: {
			marginTop: theme.spacing(2),
		},
		dialogPaper: {
			maxWidth: 560, // Figma modal width
			width: "100%",
		},
		// Sits outside the scrolling DialogContent so the buttons stay pinned. No top border:
		// the Figma frame shows the actions on the same surface as the fields (unlike the Add
		// Member dialog, whose longer content scrolls under a rule).
		dialogActions: {
			padding: "16px 24px",
			backgroundColor: theme.palette.background.paper,
		},
		fields: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2), // Figma: 16px between fields
		},
		container: {
			[theme.breakpoints.down("sm")]: {
				height: "100%",
			},
		},
		errorMessage: {
			color: theme.palette.error.main,
			fontSize: "0.75rem",
			fontWeight: "bold",
		},
		iconContainer: {
			display: "flex",
			justifyContent: "center",
		},
		// Figma: "General" section heading above the modal's fields. Overrides the global
		// subtitle1 size the same way the Add Member dialog's sectionTitle does.
		sectionHeader: {
			fontSize: 16,
			fontWeight: 700,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
			marginBottom: theme.spacing(2), // Figma: 16px heading → first field
		},
		loadingIndicatorContainer: {
			alignItems: "center",
			display: "flex",
			height: 400,
			justifyContent: "center",
			width: 400,
			[theme.breakpoints.down("sm")]: {
				flex: 1,
				height: "100%",
				width: "100%",
			},
		},
	} satisfies Record<string, CSSObject>);
};
